<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-flex align-items-center">
          <span class="toolbar-title">{{ label_als_procedures }}</span>
        </div>
        <div class="col-sm-12 col-md-7 d-flex align-items-center">
          <nav mat-tab-nav-bar #tabs [tabPanel]="tabPanel" class="full-width">
            <a
              mat-tab-link
              *ngFor="let link of links"
              (click)="onTabChanged(link)"
              [routerLink]="['/procedure-all']"
              [queryParams]="{ tab: links.indexOf(link) }"
              [active]="activeLink == link"
            >
              {{ link }}
            </a>
          </nav>
          <mat-tab-nav-panel #tabPanel class="flex flex-col flex-auto h-full">
            <div>
              <router-outlet></router-outlet>
            </div>
          </mat-tab-nav-panel>
        </div>
        <div class="col-sm-12 col-md-3 d-flex justify-content-end align-items-center">
          <mat-slide-toggle
            color="warn"
            class="float-right m-1"
            [(ngModel)]="showInactive"
          >
            <span [innerHTML]="label_show_inactive"></span>
          </mat-slide-toggle>
          <mat-slide-toggle
            *ngIf="canAccessArchivedProcedureLinks"
            color="warn"
            class="float-right m-1"
            [(ngModel)]="showArchived"
          >
            <span [innerHTML]="label_show_archived"></span>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #sidenav class="builder-sidenav" mode="side" opened="true">
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>
        <mat-list-item style="height: unset">
          <div *ngIf="isExpanded" class="full-width">
            <div class="left-table-container table-container mat-container">
              <mat-table [dataSource]="categoriesDS">
                <ng-container matColumnDef="category">
                  <mat-header-cell
                    mat-header-cell
                    *matHeaderCellDef
                    [innerHTML]="label_categories"
                  ></mat-header-cell>
                  <mat-cell *matCellDef="let e">
                    {{ e.name }}
                    <!-- <a href="{{ '#_' + e?.id }}" class="table-row">{{
                      e.name
                    }}</a> -->
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="categoriesColumns; sticky: true"
                ></mat-header-row>
                <mat-row
                  mat-row
                  *matRowDef="let row; columns: categoriesColumns"
                  (click)="navigate(row.id)"
                ></mat-row>
              </mat-table>
            </div>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <div class="row">
            <div class="col">
              <div *ngIf="tabIndex == 0">
                <div id="tables" class="p-3">
                  <div
                    id="{{ '_' + category.id }}"
                    *ngFor="let category of procedureCategories"
                  >
                    <!-- <div class="title">
                        <h5 id="{{ category.name }}">{{ category.name }}</h5>
                      </div> -->
                    <div class="mat-container mb-3">
                      <procedure-table
                        #procedureUpdateTable1
                        [procedureCategoryID]="category.id"
                        [filter]="filter"
                        [showInactive]="showInactive"
                        [showArchived]="showArchived"
                        (loading)="setLoading($event, loadingOrigin.Main)"
                      ></procedure-table>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="tabIndex == 1">
                <div class="p-3">
                  <div
                    id="{{ '_' + category.id }}"
                    *ngFor="let category of rssTestCategories"
                  >
                    <div class="mat-container mb-3">
                      <procedure-table
                        #procedureUpdateTable3
                        [procedureCategoryID]="category.id"
                        [filter]="filter"
                        [showInactive]="showInactive"
                        [showArchived]="showArchived"
                        (loading)="setLoading($event, loadingOrigin.Main)"
                      ></procedure-table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="tabIndex == 2">
                <div class="p-3">
                  <div
                    id="{{ '_' + category.id }}"
                    *ngFor="let category of epsTestCategories"
                  >
                    <div class="mat-container mb-3">
                      <procedure-table
                        #procedureUpdateTable4
                        [procedureCategoryID]="category.id"
                        [filter]="filter"
                        [showInactive]="showInactive"
                        [showArchived]="showArchived"
                        (loading)="setLoading($event, loadingOrigin.Main)"
                      ></procedure-table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="tabIndex == 3">
                <div class="p-3">
                  <div
                    id="{{ '_' + category.id }}"
                    *ngFor="let category of epsDrawingsCategories"
                  >
                    <div class="mat-container mb-3">
                      <procedure-table
                        #procedureUpdateTable5
                        [procedureCategoryID]="category.id"
                        [filter]="filter"
                        [showInactive]="showInactive"
                        [showArchived]="showArchived"
                        (loading)="setLoading($event, loadingOrigin.Main)"
                      ></procedure-table>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="tabIndex == 4">
                <div class="p-3">
                  <div
                    id="{{ '_' + category.id }}"
                    *ngFor="let category of radSurveyCategories"
                  >
                    <div class="mat-container mb-3">
                      <procedure-table
                        #procedureUpdateTable6
                        [procedureCategoryID]="category.id"
                        [filter]="filter"
                        [showInactive]="showInactive"
                        [showArchived]="showArchived"
                        (loading)="setLoading($event, loadingOrigin.Main)"
                      ></procedure-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading" [message]="loadingMessage">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
